import React, { useState } from 'react';
import ChatInterface from './components/ChatInterface';
import { MortgageFlowProvider } from './context/MortgageFlowContext';
import { getTranslation } from './utils/translations';
import './App.css';

function App() {
  const [language, setLanguage] = useState('ru');
  const [showClients, setShowClients] = useState(false);
  const [showLoanApp, setShowLoanApp] = useState(true); // Active by default

  return (
    <div className="App">
      <MortgageFlowProvider>
        <div className="app-header">
          <h1>🏠 Mortgage Application Assistant</h1>
        </div>
        <div className="language-selector-bar">
          <div className="flag-selector">
            <button 
              className={`flag-button ${language === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
              title="English"
            >
              🇺🇸
            </button>
            <button 
              className={`flag-button ${language === 'ky' ? 'active' : ''}`}
              onClick={() => setLanguage('ky')}
              title="Кыргызча"
            >
              🇰🇬
            </button>
            <button 
              className={`flag-button ${language === 'ru' ? 'active' : ''}`}
              onClick={() => setLanguage('ru')}
              title="Русский"
            >
              🇷🇺
            </button>
          </div>
        </div>
        <div className="clients-bar">
          <button 
            className={`loan-app-button ${showLoanApp ? 'active' : ''}`}
            onClick={() => {
              setShowLoanApp(true);
              setShowClients(false);
            }}
          >
            {getTranslation('loanApplication', language)}
          </button>
          <button 
            className={`our-clients-button ${showClients ? 'active' : ''}`}
            onClick={() => {
              setShowClients(true);
              setShowLoanApp(false);
            }}
          >
            {getTranslation('ourClients', language)}
          </button>
        </div>
        <ChatInterface 
          language={language} 
          onLanguageChange={setLanguage} 
          showClients={showClients}
          showLoanApp={showLoanApp}
        />
      </MortgageFlowProvider>
    </div>
  );
}

export default App;